import { Checkbox, Col, Modal, Row } from 'antd';
import React, { useEffect } from 'react';
import formatNumber from 'utils/formatNumber';
import { openNotificationWithIcon } from 'utils/notification';

interface IProps {
  open: boolean;
  setOpen: any;
  dataCheckbox: any;
  setSelectedTuCopy: any;
  getFullMinMaxCartOrder: any;
  selectedTuCopy: any;
}

const ModalCopyCart = ({
  open,
  setOpen,
  dataCheckbox,
  setSelectedTuCopy,
  getFullMinMaxCartOrder,
  selectedTuCopy,
}: IProps) => {
  const handleCopyCart = () => {
    if (selectedTuCopy?.length > 0) {
      getFullMinMaxCartOrder();
      setOpen((prev: boolean) => !prev);
    } else {
      openNotificationWithIcon('error', 'Chưa chọn tủ để sao chép!!');
    }
  };

  const onChange = (checkedValues: any[]) => {
    setSelectedTuCopy(checkedValues);
  };

  const handleCancel = () => {
    setSelectedTuCopy([]);
    setOpen(false);
  };

  return (
    <Modal
      title="Chọn tủ Xman bạn muốn sao chép"
      centered
      open={open}
      onOk={handleCopyCart}
      onCancel={handleCancel}
      width={500}
    >
      <Checkbox.Group
        value={selectedTuCopy}
        className="w-full my-3"
        onChange={onChange}
      >
        <Row>
          <Col className="mb-2" span={12}>
            <Checkbox value="all">
              {' '}
              {'Tất cả' +
                ' (' +
                formatNumber(
                  dataCheckbox?.reduce(
                    (total: any, item: any) => (total += item.sl_mau_ky_cu),
                    0
                  )
                ) +
                ')'}{' '}
            </Checkbox>
          </Col>
          {dataCheckbox?.map((item: any) => {
            return (
              <Col className="mb-2" key={item?.code} span={12}>
                <Checkbox value={item?.code}>
                  {' '}
                  {item?.name + ' (' + (item?.sl_mau_ky_cu || 0) + ')'}
                </Checkbox>
              </Col>
            );
          })}
        </Row>
      </Checkbox.Group>
    </Modal>
  );
};

export default ModalCopyCart;
